import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatSelectionList, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FsService } from '../../../fs.service';
import { ShiftsService } from '../../../shifts.service';
import { SelectionModel } from '@angular/cdk/collections';
import { TransactionService } from '../../../transaction.service';

@Component({
  selector: 'app-edit-fs',
  templateUrl: './edit-fs.component.html',
  styleUrls: ['./edit-fs.component.scss']
})

export class EditFsComponent implements OnInit {

  columns: any = ['name'];
  fss: any = [];
  fsOg: any = [];
  shifts: any = [];
  selectedFs: any = [];
  selectedShift = '';
  siteName = '';
  siteId = '';
  itemId = '';
  clickedItem: any;
  @ViewChild(MatSelectionList) fsMatList: MatSelectionList;

  constructor(
    public dialogRef: MatDialogRef<EditFsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fsService: FsService,
    private shiftService: ShiftsService,
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.itemId = this.data.itemId;
    this.siteName = this.data.site;
    this.siteId = this.data.siteId;
    this.fss = this.fsOg;
    this.fsMatList.selectedOptions = new SelectionModel(false);
    this.clickedItem = this.data.clickedItem;
    this.getSupervisorList();
    this.getShifts(this.siteName);
  }

  getSupervisorList() {
    this.fsService.getSupervisorList()
      .subscribe((data) => {
        this.fsOg = data;
        this.applyFsFilter('');
    });
  }

  getShifts(site: string) {
    this.shiftService.getShifts(site)
      .subscribe((data) => {
        this.shifts = data;
      });
  }

  addClicked() {
    if (this.selectedFs.length === 0) {
      alert('You must select a Shift Leader to allocate');
      return;
    }
    if (this.selectedShift === '') {
      alert('You must select a shift to allocate');
      return;
    }
    this.updateFs();
  }

  closeClicked() {
    this.dialogRef.close({result: 'cancelled'});
  }

  applyFsFilter(filterValue: string) {
    this.fss = this.fsOg;
    this.fss = Object.assign([], this.fsOg).filter(
      item => item.name.toLowerCase().indexOf(filterValue.toLowerCase()) > -1 || item.id.toString().indexOf(filterValue) > -1
    );
  }

  assignFs(fs: any) {
    if (this.fsMatList.selectedOptions.selected.length === 0) {
      this.selectedFs = [];
    } else {
      this.selectedFs = [fs];
    }
  }

  onShiftChange(shift: any) {
    this.selectedShift = shift;
  }

  updateFs() {
    this.fsService.updateSupervisor(this.itemId, this.siteId, this.selectedShift, this.selectedFs[0].id, localStorage.getItem('userFullName'))
    .subscribe((data) => {
      // creating a new supervisor from client side without refreshing
      // some data can't be added like: email, phone, siteAddress, agencyRequirements
      const supervisor = {
        amEndH: 15,
        amEndM: 0,
        amStartH: 6,
        amStartM: 30,
        c1label: 'DAY',
        c2label: 'AFTERNOON',
        c3label: 'MIDNIGHT',
        c4EndH: 0,
        c4EndM: 0,
        c4StartH: 0,
        c4StartM: 0,
        c4label: '',
        c5EndH: 0,
        c5EndM: 0,
        c5StartH: 0,
        c5StartM: 0,
        c5label: '',
        c6EndH: 0,
        c6EndM: 0,
        c6StartH: 0,
        c6StartM: 0,
        c6label: '',
        id: this.selectedFs[0].id,
        isFri: 1,
        isMon: 1,
        isSat: 0,
        isSun: 0,
        isThurs: 1,
        isTues: 1,
        isWed: 1,
        itemId: this.itemId,
        mnEndH: 7,
        mnEndM: 0,
        mnStartH: 22,
        mnStartM: 30,
        name: this.selectedFs[0].name,
        pmEndH: 23,
        pmEndM: 0,
        pmStartH: 14,
        pmStartM: 30,
        shift: this.selectedShift
      };

      if (data.length === 0) {
        this.dialogRef.close({
          result: 'success',
          supervisor
        });

        this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift,
        'Shift Leader ' + this.clickedItem.name + ' for ' + this.clickedItem.shift + ' shift updated to ' +
        this.selectedFs[0].name + ' for ' + this.selectedShift + ' shift at ' + this.siteName)
          .subscribe((tdata) => {
          }
        );
      } else {
        alert('Something went wrong');
        this.dialogRef.close({result: 'error'});
      }
    });
  }

}
